export const CSS_CUSTOM_HEADER = "\n\n/* CUSTOM STYLES */\n\n" ; 
export function loadCustomCss(editor, customCss){
    const rootNode = editor.Canvas.getDocument() ;

    let styleTag = rootNode.getElementById("style_custom") ;
    if(!styleTag){ 
        styleTag = document.createElement('style');
        styleTag.id = "style_custom" ;
        styleTag.setAttribute('type', 'text/css');
        rootNode.querySelector("head").appendChild(styleTag);
    }else{
        styleTag.innerHTML = "" ;
    }
    styleTag.appendChild(document.createTextNode(customCss));
}
export function panelEditCss(editor){

    let originalGetCss = editor.getCss ;
    editor.getCss = function(){
        let css = originalGetCss.apply(this) ; 
        const rootNode = editor.Canvas.getDocument() ;

        if(rootNode){
            const styleTag = rootNode.getElementById("style_custom") ;
            if(styleTag){
                css += CSS_CUSTOM_HEADER+styleTag.innerHTML ;
            }
        }
        return css;
    } ;


    editor.Panels.addButton('options', [{
        id: "edit-css",
        className: 'fab fa-css3-alt',
        command: "edit-css",
        attributes: { title: window.tr("components.actions.editCss") }
      }]);

      editor.Commands.add("edit-css", {
        run: function (editor, sender) {
            sender && sender.set('active', 0);

            const rootNode = editor.Canvas.getDocument() ;

            const styleTag = rootNode.getElementById("style_custom") ;
            let allCss = "" ;
            if(styleTag){
                allCss = styleTag.innerHTML ;
            }

            // const allCss = editor.getCss({avoidProtected: true })
            // .replace(/\{/g, " {\n\t")
            // .replace(/\}/g, "}\n\n")
            // .replace(/;/g, ";\n\t")
            // .replace(/\t\}/g, "}") ;
           
            let divPopup = document.createElement("DIV") ;
            divPopup.innerHTML = `<div id="monaco-editor" style="height: calc(100vh - 200px);"></div>
            <div>
                <button id="apply-btn" class="gjs-btn-prim">Apply code</button>
            </div>`;

            editor.Modal.setTitle(window.tr("components.actions.editCss"));
            editor.Modal.setContent(divPopup);
            editor.Modal.open();
            

            let monaco_editor = null;

            const cssModel = window.monaco.editor.createModel(allCss, 'css');

            monaco_editor = window.monaco.editor.create(divPopup.querySelector('#monaco-editor'), {
                model: cssModel,
                minimap: {
                    enabled: false
                },
                wordWrap: "on",
                language: 'css'
            }); 

            const apply_btn = document.getElementById('apply-btn');
            apply_btn.addEventListener('click', () => {
                // editor.setStyle(cssModel.getValue());

                loadCustomCss(editor, cssModel.getValue()) ;

                editor.Modal.close();
            });
        }
    });
}